import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { FadeIn, Section, SectionTitle, Accent, Stars, pad2 } from './Shared';
import { OfferCard } from './CoreSections';
import { useCountdown } from '../hooks/useCountdown';
import { coachTestimonials } from '../data/testimonials';
import { faqs } from '../data/faqs';
import { ShieldCheck, Plus, Clock, Lock, CreditCard, ArrowRightIcon, MailIcon, AtSignIcon, MapPinIcon } from 'lucide-react';
export const Testimonials2 = () => <Section className="bg-slate-950" data-id="element-177" data-mp="136z3mjiehzvz">
    <FadeIn data-id="element-178" data-mp="13a4qrt7gyrp2">
      <SectionTitle sub={<span className="inline-flex flex-wrap items-center justify-center gap-2" data-id="element-180" data-mp="phf2tj8drcpb">
            <Stars size={14} data-id="element-181" data-mp="thp8svw6a346" />
            <span className="font-semibold text-white" data-id="element-182" data-mp="tgwamjba4lxn">4.9/5</span>
            <span data-id="element-183" data-mp="1h79tpkbvzag3">· +150 entrenadores de Latinoamérica</span>
          </span>} data-id="element-179" data-mp="pglvag1lkj64">
        Lo que dicen <Accent data-id="element-184" data-mp="1lyrvgalqhf24">los profes</Accent>
      </SectionTitle>
    </FadeIn>

    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4" data-id="element-185" data-mp="31mnqag9as0j4">
      {coachTestimonials.map((t, i) => <FadeIn key={t.name} delay={Math.min(i * 0.05, 0.15)} data-id="element-186" data-mp="2wo325f7bl7b1" data-mpi={i}>
          <figure className="flex h-full flex-col rounded-2xl border border-white/10 bg-white/[0.03] p-5" data-id="element-187" data-mp="2wlhyqlrdijb6">
            <Stars data-id="element-188" data-mp="3beacf7n6bk0n" />
            <blockquote className="mt-3 text-[15px] leading-relaxed text-slate-200" data-id="element-189" data-mp="36m0nnuxsopzy">“{t.text}”</blockquote>
            <figcaption className="mt-auto flex items-center gap-3 pt-5" data-id="element-190" data-mp="3kcm83o2wd7zy">
              <div className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full ${t.bg} text-xs font-bold text-white`} data-id="element-191" data-mp="3gbk8v78zcvxz">
                {t.initials}
              </div>
              <div className="min-w-0" data-id="element-192" data-mp="3u98rs9jhlt0e">
                <p className="text-sm font-semibold leading-tight text-white" data-id="element-193" data-mp="3pbqksop15nv1">{t.name}</p>
                <p className="flex items-center gap-1 text-xs text-slate-500" data-id="element-194" data-mp="1zx296po9k9y2">
                  <MapPinIcon size={11} aria-hidden="true" data-id="element-195" data-mp="1zz53hlwg8p8l" /> {t.location} · {t.product}
                </p>
              </div>
            </figcaption>
          </figure>
        </FadeIn>)}
    </div>
  </Section>;
export const Guarantee = () => <Section className="bg-slate-900/40" data-id="element-196" data-mp="3v78fe5ofzkn">
    <FadeIn className="mx-auto grid max-w-4xl items-center gap-8 rounded-3xl border border-emerald-500/25 bg-emerald-500/[0.05] p-6 md:grid-cols-[auto_1fr] md:gap-12 md:p-12" data-id="element-197" data-mp="3w0fyhcgmt3u">
      <div className="mx-auto flex h-28 w-28 items-center justify-center rounded-full border border-emerald-500/30 bg-emerald-500/10 md:h-36 md:w-36" data-id="element-198" data-mp="cwf03ddou25r">
        <div className="text-center" data-id="element-199" data-mp="msi3emka06ua">
          <ShieldCheck size={36} className="mx-auto text-emerald-400" aria-hidden="true" data-id="element-200" data-mp="mrgrkfvfrgbi" />
          <p className="mt-1 font-display text-2xl font-black italic leading-none text-white md:text-3xl" data-id="element-201" data-mp="rl1hdkmvl3zm">7 días</p>
        </div>
      </div>
      <div className="text-center md:text-left" data-id="element-202" data-mp="vn66q76ajegg">
        <h2 className="font-display text-3xl font-black uppercase italic leading-[1.05] tracking-tight text-white md:text-5xl" data-id="element-203" data-mp="10lhgyj0hzqz7">
          Garantía 7 días — <span className="text-emerald-400" data-id="element-204" data-mp="15h6ksyjjvu1b">sin preguntas</span>
        </h2>
        <div className="mt-5 space-y-3 text-base leading-relaxed text-slate-300 md:text-lg" data-id="element-205" data-mp="1forc9actr95t">
          <p data-id="element-206" data-mp="1ams9a1kzye9e">Abres los tomos. Los usas en tus clases.</p>
          <p className="text-lg font-semibold leading-snug text-white md:text-xl" data-id="element-207" data-mp="15oqq7gnkmexx">
            Si en 7 días no es lo que esperabas: devolución del 100%.
          </p>
          <p data-id="element-208" data-mp="11q1dzre9r3fv">Sin formularios. Sin complicaciones. Sin vueltas.</p>
        </div>
        <p className="mt-5 text-xs font-semibold uppercase tracking-widest text-slate-500" data-id="element-209" data-mp="1yd60xqzo6b3g">
          Tasa de devoluciones: menos del 2%.
        </p>
      </div>
    </FadeIn>
  </Section>;
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="bg-slate-950" data-id="element-210" data-mp="1km19hc6ggp47">
      <div className="grid gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16" data-id="element-211" data-mp="2h4fdk94qlfz9">
        <FadeIn className="text-center lg:text-left" data-id="element-212" data-mp="2h5qiwddtyvsh">
          <h2 className="font-display text-4xl font-black uppercase italic leading-[1.05] tracking-tight text-white md:text-6xl" data-id="element-213" data-mp="2cdgrsu0zbpom">
            Lo que más nos <Accent data-id="element-214" data-mp="1wxs8i3qh5gig">preguntan</Accent>
          </h2>
          <p className="mt-4 text-slate-400" data-id="element-215" data-mp="21v2646o0oyhd">
            ¿Otra duda? Escríbenos a{' '}
            <a href="mailto:soportecentershop95@gmail.com" className="font-medium text-sky-400 underline-offset-4 hover:underline" data-id="element-216" data-mp="1nviydez4bp5l">
              soportecentershop95@gmail.com
            </a>
          </p>
        </FadeIn>
        <FadeIn delay={0.05} data-id="element-217" data-mp="2fn8c4zxghp33">
          <div className="divide-y divide-white/10 border-y border-white/10" data-id="element-218" data-mp="2fmysdu308e5u">
            {faqs.map((faq, i) => {
            const isOpen = openIndex === i;
            return <div key={faq.q} data-id="element-219" data-mp="26tdf6f6hn4yj" data-mpi={i}>
                  <h3 data-id="element-220" data-mp="2avguxg06wvpm">
                    <button id={`faq-q-${i}`} className="flex w-full items-center justify-between gap-4 rounded-md py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-400" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-a-${i}`} data-id="element-221" data-mp="2auysg1mxpl99">
                      <span className="text-base font-semibold text-white md:text-lg" data-id="element-222" data-mp="mx6bqank6qx6">{faq.q}</span>
                      <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-[transform,background-color] duration-200 ease-out ${isOpen ? 'rotate-45 bg-blue-600 text-white' : 'bg-white/5 text-slate-300'}`} aria-hidden="true" data-id="element-223" data-mp="11m2gnyubjntk">
                        <Plus size={16} data-id="element-224" data-mp="417reg0qhx0p" />
                      </span>
                    </button>
                  </h3>
                  <AnimatePresence initial={false} data-id="element-225" data-mp="dxaxty2mchtg">
                    {isOpen && <motion.div id={`faq-a-${i}`} role="region" aria-labelledby={`faq-q-${i}`} initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.22,
                  ease: [0.23, 1, 0.32, 1]
                }} className="overflow-hidden" data-id="element-226" data-mp="1ub9hj4h8wphz">
                        <p className="pb-5 pr-12 text-[15px] leading-relaxed text-slate-300 md:text-base" data-id="element-227" data-mp="2bcdnsfmcr0if">{faq.a}</p>
                      </motion.div>}
                  </AnimatePresence>
                </div>;
          })}
          </div>
        </FadeIn>
      </div>
    </Section>;
};
export const CostOfNotHaving = () => {
  const costs = [{
    sin: '3hs buscando sesiones por semana',
    costo: '156hs por año'
  }, {
    sin: 'Clases sin estructura',
    costo: 'Grupo que abandona'
  }, {
    sin: 'Sin adaptaciones por nivel',
    costo: 'El alumno nuevo no vuelve'
  }, {
    sin: 'Sin programa anual',
    costo: 'Los mismos circuitos'
  }, {
    sin: 'Domingo buscando ideas en redes',
    costo: 'Mismo ciclo cada año'
  }];
  return <Section className="bg-slate-900/40" data-id="element-228" data-mp="3d6yqdeb2dgqm">
      <FadeIn className="mx-auto max-w-3xl" data-id="element-229" data-mp="396g03ootkiqj">
        <SectionTitle data-id="element-230" data-mp="396o9h6lqh5wz">
          ¿Cuánto cuesta
          <br data-id="element-231" data-mp="346tlpbx98wg5" /> <Accent data-id="element-232" data-mp="346k3wbmd5vlj">no tenerlo?</Accent>
        </SectionTitle>

        <div className="overflow-hidden rounded-2xl border border-white/10 bg-white/[0.03]" data-id="element-233" data-mp="34969w6tlw31n">
          <table className="w-full text-left" data-id="element-234" data-mp="2z7qm4701nifk">
            <thead data-id="element-235" data-mp="2u9fcnxdnv9xv">
              <tr className="border-b border-white/10 bg-white/[0.04]" data-id="element-236" data-mp="2u9p7by9ni59w">
                <th scope="col" className="w-1/2 px-4 py-3.5 text-xs font-semibold uppercase tracking-wide text-slate-400 md:px-6 md:text-sm" data-id="element-237" data-mp="2phnlbkmol06o">
                  Sin el MEGAPACK
                </th>
                <th scope="col" className="w-1/2 border-l border-white/10 px-4 py-3.5 text-xs font-semibold uppercase tracking-wide text-white md:px-6 md:text-sm" data-id="element-238" data-mp="2gi0vzx787ktz">
                  Costo real
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-white/5" data-id="element-239" data-mp="26k37d8lgfm0u">
              {costs.map(row => <tr key={row.sin} data-id="element-240" data-mp="3vea9289xmd2a">
                  <td className="px-4 py-4 text-sm leading-snug text-slate-400 md:px-6 md:text-base" data-id="element-241" data-mp="39pzg9gg9t7h">{row.sin}</td>
                  <td className="border-l border-white/10 px-4 py-4 text-sm font-medium leading-snug text-red-400 md:px-6 md:text-base" data-id="element-242" data-mp="3lfuiq7iqb7tu">
                    <span className="inline-flex items-start gap-1.5" data-id="element-243" data-mp="3qcumgbs3vyhs">
                      <ArrowRightIcon size={14} className="mt-0.5 shrink-0 md:mt-1" aria-hidden="true" data-id="element-244" data-mp="3bp9jchv8dz9v" />
                      {row.costo}
                    </span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <p className="mt-8 text-center text-lg font-semibold text-white md:text-xl" data-id="element-245" data-mp="37nodhgh46l96">
          Tu próximo entrenamiento puede ser diferente...
        </p>
      </FadeIn>
    </Section>;
};
const trustItems = [{
  icon: Lock,
  label: 'Pago 100% seguro'
}, {
  icon: Clock,
  label: 'Acceso en 5 minutos'
}, {
  icon: ShieldCheck,
  label: 'Garantía 7 días'
}, {
  icon: CreditCard,
  label: 'Tarjeta | Débito | Pago local en tu moneda'
}];
export const FinalCTA = () => {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <Section className="border-t border-white/5 bg-slate-950 !pb-28 md:!pb-24" data-id="element-246" data-mp="2o35y1tvrbzpb">
      <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-247" data-mp="2j2i87bj9lowo">
        <FadeIn className="text-center lg:text-left" data-id="element-248" data-mp="2x2t1smbylhlj">
          <h2 className="font-display text-[32px] font-black uppercase italic leading-[1.08] tracking-tight text-white md:text-6xl" data-id="element-249" data-mp="2x1hw2gyydzrs">
            Puedes <Accent data-id="element-250" data-mp="2szehvkkwgh2t">improvisar</Accent> la siguiente clase, o entrar con todo resuelto.
          </h2>
          <p className="mt-4 font-display text-3xl font-black uppercase italic text-sky-400 md:text-4xl" data-id="element-251" data-mp="31tj6dxck9gf6">
            Tú decides.
          </p>

          <div className="mt-8 inline-flex flex-col items-center gap-3 lg:items-start" data-id="element-252" data-mp="3grv2o2w0un5t">
            <p className="inline-flex items-center gap-2 rounded-full bg-red-500/15 px-3 py-1 text-xs font-bold uppercase tracking-widest text-red-400" data-id="element-253" data-mp="3bsi7muuzy9s5">
              <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-red-400" aria-hidden="true" data-id="element-254" data-mp="3dzlflr5364rf" />
              Última oportunidad · el precio cierra en
            </p>
            <p className="font-display text-5xl font-black tabular-nums leading-none tracking-tight text-white md:text-6xl" role="timer" aria-live="off" data-id="element-255" data-mp="348gyolvuo9ty">
              {pad2(hours)}
              <span className="text-slate-600" data-id="element-256" data-mp="q5rvznd1hly">:</span>
              {pad2(minutes)}
              <span className="text-slate-600" data-id="element-257" data-mp="3rxa1n2aw3hy2">:</span>
              {pad2(seconds)}
            </p>
            <p className="text-xs font-semibold uppercase tracking-widest text-slate-500" data-id="element-258" data-mp="3nv58e4ocsnby">
              Después sube. No vuelve a este precio.
            </p>
          </div>

          <ul className="mt-8 hidden flex-wrap gap-x-6 gap-y-2 text-sm text-slate-400 lg:flex" data-id="element-259" data-mp="2cghytofl8mw1">
            {trustItems.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-2" data-id="element-260" data-mp="27gdf7pjdvc1l">
                <Icon size={14} aria-hidden="true" data-id="element-261" data-mp="n0fescbh00e0" /> {label}
              </li>)}
          </ul>
        </FadeIn>

        <FadeIn delay={0.05} className="mx-auto w-full max-w-md" data-id="element-262" data-mp="rz8pjwzdhdah">
          <OfferCard id="final-offer" footnote="Pago único · Incluye garantía de 7 días" checklist={['6 Tomos principales — 365 sesiones', '5 Bonos estratégicos incluidos', 'Versiones A/B/C por nivel', 'Acceso inmediato y para siempre']} data-id="element-263" data-mp="w02e8skn2w4f" />
        </FadeIn>

        <ul className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-slate-400 lg:hidden" data-id="element-264" data-mp="1fobgjvfwcihn">
          {trustItems.map(({
          icon: Icon,
          label
        }, i) => <li key={label} className={`flex items-center gap-1.5 ${i === trustItems.length - 1 ? 'w-full justify-center' : ''}`} data-id="element-265" data-mp="1jp3s4vc8qzh3" data-mpi={i}>
              <Icon size={13} aria-hidden="true" data-id="element-266" data-mp="3lh9we0au8ul9" /> {label}
            </li>)}
        </ul>
      </div>
    </Section>;
};
export const Footer = () => <footer className="border-t border-white/5 bg-slate-950 px-5 pb-28 pt-12 md:px-8 md:pb-12" data-id="element-267" data-mp="snb8qajv3o4e">
    <div className="mx-auto flex max-w-6xl flex-col gap-8 md:flex-row md:items-start md:justify-between" data-id="element-268" data-mp="np9gaz0jqcg9">
      <div className="max-w-sm text-center md:text-left" data-id="element-269" data-mp="11p0xt9q9uaz0">
        <p className="font-display text-xl font-black uppercase italic tracking-tight text-white" data-id="element-270" data-mp="xlcq8r1n3fdr">
          MEGAPACK Funcional <Accent data-id="element-271" data-mp="1bklzf6rfh988">365™</Accent>
        </p>
        <p className="mt-1 text-xs font-semibold uppercase tracking-widest text-slate-500" data-id="element-272" data-mp="1bjasiy2orlcw">
          by Center Shop Digital
        </p>
        <p className="mt-4 text-sm leading-relaxed text-slate-400" data-id="element-273" data-mp="1lbqb9xlt4dyu">
          El sistema de clases listas número 1 para instructores y coaches de
          funcional en Latinoamérica. Porque dar una buena clase no debería
          costarte todos los domingos del año.
        </p>
      </div>
      <div className="flex flex-col items-center gap-3 text-sm text-slate-400 md:items-end" data-id="element-274" data-mp="1pdk97y4mb3vb">
        <a href="mailto:soportecentershop95@gmail.com" className="inline-flex items-center gap-2 transition-colors duration-150 hover:text-white" data-id="element-275" data-mp="28z3qqzp0j1kr">
          <MailIcon size={14} aria-hidden="true" data-id="element-276" data-mp="2dxezf73kn61e" /> soportecentershop95@gmail.com
        </a>
        <a href="#" className="inline-flex items-center gap-2 transition-colors duration-150 hover:text-white" data-id="element-277" data-mp="1zxmanhbluzw2">
          <AtSignIcon size={14} aria-hidden="true" data-id="element-278" data-mp="23xxuwt022y70" /> centershop.digital
        </a>
      </div>
    </div>
    <div className="mx-auto mt-10 flex max-w-6xl flex-col items-center gap-3 border-t border-white/5 pt-6 text-xs text-slate-500 md:flex-row md:justify-between" data-id="element-279" data-mp="1q71c1tvxlvd5">
      <p className="text-center md:text-left" data-id="element-280" data-mp="1gb7ufw3cvboi">
        © 2024 Center Shop Digital. Todos los derechos reservados. Precios en
        dólares (USD) · Cobro en tu moneda local.
      </p>
      <p className="flex gap-4" data-id="element-281" data-mp="178yn1f3dvyfc">
        <a href="#" className="transition-colors duration-150 hover:text-white" data-id="element-282" data-mp="17a09efpuo7cd">Términos y condiciones</a>
        <a href="#" className="transition-colors duration-150 hover:text-white" data-id="element-283" data-mp="1c7ryz330vhde">Política de privacidad</a>
      </p>
    </div>
  </footer>;